import WebComponent from '../base/WebComponent';

class StepNotFound extends WebComponent {
    template() {
        return `
            <div class="flexy align--center justify--center">
                <h1 class="stepform__headline">Hvordan kom du hertil?</h1>
            </div>    
        `;
    }
}

customElements.define( 'step-not-found', StepNotFound );
